import { createSlice } from '@reduxjs/toolkit'

const configSlice = createSlice({
  name: 'config',
  initialState: {
    api: process.env.CLIENT_API_URL
  }
})

export const getApiUrl = state => process.env.API_URL || state.config.api
export const getGlobalContentApiUrl = state => getApiUrl(state) + '/global'
export const getShopApiUrl = state => getApiUrl(state) + '/shop'
export const getContentApiUrl = state => getApiUrl(state) + '/content'
export const getPagesApiUrl = state => getApiUrl(state) + '/page'
export const getPreviewApiUrl = state => getApiUrl(state) + '/preview'
export const isApiAccessTokenInvalid = state => state.config.invalidToken

export default configSlice.reducer
